export interface DefaultImage {
  name: string
  smallUrl: string
  retinaUrl: string
  url: string
  backRemovedUrl: string
  alt: string
}

export const HomeDefaultImages: () => DefaultImage[] = () => {
  const config = useRuntimeConfig()
  return [
    {
      name: 'magvi.png',
      smallUrl: '/home-img-1.webp',
      retinaUrl: '/home-img-1_2x.webp',
      url: config.public.appUrl + '/storage/default/1.png',
      backRemovedUrl: config.public.appUrl + '/storage/default/1-prepared.png',
      alt: 'Рюкзак для создания инфографики',
    },
    {
      name: 'magvi.png',
      smallUrl: '/home-img-2.webp',
      retinaUrl: '/home-img-2_2x.webp',
      url: config.public.appUrl + '/storage/default/2.png',
      backRemovedUrl: config.public.appUrl + '/storage/default/2-prepared.png',
      alt: 'Подушка для создания инфографики',
    },
    {
      name: 'magvi.png',
      smallUrl: '/home-img-3.webp',
      retinaUrl: '/home-img-3_2x.webp',
      url: config.public.appUrl + '/storage/default/3.png',
      backRemovedUrl: config.public.appUrl + '/storage/default/3-prepared.png',
      alt: 'Тапочки для создания инфографики',
    },
    {
      name: 'magvi.png',
      smallUrl: '/home-img-4.webp',
      retinaUrl: '/home-img-4_2x.webp',
      url: config.public.appUrl + '/storage/default/4.png',
      backRemovedUrl: config.public.appUrl + '/storage/default/4-prepared.png',
      alt: 'Кроссовки для создания инфографики',
    },
  ]
}
